import React from 'react';
import cat from './img/cat.png'; 
import armenia from './img/armenia.png'; 
import usclogo from './img/usclogo.png'; 
import usc from './img/usc.png'; 
import slalom from './img/slalom.png'; 
import gtech from './img/gtech.png'; 
import awt from './img/awt.jpeg';
import qb from './img/qb.png';
import twitter from './img/twitter.webp'; 
import linkedin from './img/linkedin.webp';
import github from './img/github.png';
import './index.css';
import NavBar from './navBar.js';
import Education from './education.js';
import Work from './work.js';
import PreWork from './pre-swe-work.js';
import Projects from './projects.js';
import Awards from './awards.js';
import Form from './form.js';
import TxtToSpeech from './txtTospeech.js';
import Quotes from './quotes.js';
import { createRoot } from 'react-dom/client';

const root = createRoot(document.querySelector('#root'));

root.render(
  <React.StrictMode>
    <NavBar></NavBar>

    <div id="home">
      <div className="main">
        <div id="flex1">
          <div id="flex1-1">
            <div className="hi">
              <h1>Hi, I'm Lily!</h1>
              <TxtToSpeech
                inputText={
                  'Hi, I am Lily! Welcome to my little website that I have put together to share about myself. As a graduating senior at University of Southern California, I have encountered many valuable experiences that have shaped who I am today. Here, I have created a space where I can share key facts about myself and tell a story of how my interests and risk-taking shaped me.'
                }
              ></TxtToSpeech>

              <h3>
                Welcome to my little website that I've put together to share
                about myself...
              </h3>
            
              <a href="#projects">
                <div className="projButton">Projects</div>
              </a>

              <div className="paragraph">
                As a graduating senior at University of Southern California, I
                have encountered many valuable experiences that have shaped who
                I am today. Here, I have created a space where I can share key
                facts about myself and tell a story of how my interests and
                risk-taking shaped me.
              </div>
            </div>
          </div>
          <div id="imgdiv">
            <img
              id="profile"
              src="https://media-exp1.licdn.com/dms/image/C5603AQHaKv0i9nkWqw/profile-displayphoto-shrink_800_800/0/1655330942591?e=2147483647&v=beta&t=0CespBRAqVcs7WGRUDLRm7ZfgId6cCvOc9_80Ra4ewQ"
              alt="profile pic"
            ></img>
          </div>
        </div>
      </div>

      <div id="images">
        <h4>Let's Connect!</h4>
        <a href="https://github.com/lyengoian">
          <img
            src={github}
            alt="github"
          ></img>
        </a>
        <a href="https://www.linkedin.com/in/lilit-yengoian-6b818817a/">
          <img
            src={linkedin}
            alt="linkedin"
          ></img>
        </a>
        <a href="https://twitter.com/LYengoian">
          <img
            src={twitter}
            alt="twitter"
          ></img>
        </a>
        <h4>
          Feel free to contact me with any questions or comments as well . . .
        </h4>
        <a href="#contact">
          <div className="projButton">Contact</div>
        </a>
      </div>
    </div>

    <div id="about">
      <div className="main">
        <div className="hi">
          <h1>A Bit About Me</h1>
          <TxtToSpeech
            inputText={
              'Hello! My name is Lilit, but you can call me Lily. I am a student at University of Southern California, currenlty wrapping up my last semester here! In January, I will officially be a full-time software engineer, as well as an MS CS student at Georgia Tech! I was born in the United States, but grew up in the beautiful country of Armenia from ages 8-14. At ages 3 and 4, I lived and attended preschool in Russia, where my parents worked at the time. Through all of my moving around, I have learned to love not only my ancestral culture and history, but also that of others When I first started being a college student at USC, I was determined to become a neurologist. I loved learning about the brain and always thought that it was the most fascinating organ (I still do). However, over time, I realized that medicine was not for me. After many years dedicated to clinical volunteering and neuroscience research, I knew that neither medicine nor natural sciences was the right career path for me. Thankfully, through one of the reseach labs I volunteered at, I had learned R for statistial programming. That, combined with my frequent use of Bash and required programming course for my Neuroscience major led me to seriously consider a career in programming/software engineering. I was originally on track to graduate from USC December of 2021, but I knew that I was not finished learning. So, I picked up a minor in Computer Programming, and started to learn something completely new to me. I wanted to fast-track my graduation and find a job, so I was determined to finish the entire minor along with 2 specializations in only 2 semesters.Fast-forward to today -- I am graduating in a couple of weeks with my B.S. in Neuroscience and minor in Computer Programming, along with a couple of programming-related specializatios. I received a full-time software engineering offer at a wonderful company, so I will be starting my new job in January 2023. I also really have been enjoying my classes, and want to further dive into computer science, so I will be pursuing an M.S. in Computer Science at Georgia Tech starting in January as well! With all going well, I happened to rescue a cat from my birthplace (Pasadena, CA). So, I now have an adorable kitten named Daisy!'
            }
          ></TxtToSpeech>
        </div>
        <div id="paragraph2">
          Hello! My name is Lilit, but you can call me Lily. I am a student at
          University of Southern California, currenlty wrapping up my last
          semester here! In January, I'll officially be a full-time software
          engineer, as well as an MS CS student at Georgia Tech!
        </div>
        <p className="aboutmep">
          I was born in the United States, but grew up in the beautiful country
          of Armenia from ages 8-14. At ages 3 and 4, I lived and attended
          preschool in Russia, where my parents worked at the time. Through all
          of my moving around, I have learned to love not only my ancestral
          culture and history, but also that of others.
          <img
            id="aboutme1"
            src={armenia}
            alt="Armenia"
          ></img>
          When I first started being a college student at USC, I was determined
          to become a neurologist. I loved learning about the brain and always
          thought that it was the most fascinating organ (I still do). However,
          over time, I realized that medicine was not for me. After many years
          dedicated to clinical volunteering and neuroscience research, I knew
          that neither medicine nor natural sciences was the right career path
          for me. Thankfully, through one of the reseach labs I volunteered at,
          I had learned R for statistial programming. That, combined with my
          frequent use of Bash and required programming course for my
          Neuroscience major led me to seriously consider a career in
          programming/software engineering. I was originally on track to
          graduate from USC December of 2021, but I knew that I was not finished
          <img
            id="aboutme2"
            src={cat}
            alt="Daisy the Cat"

          ></img>
          learning. So, I picked up a minor in Computer Programming, and started
          to learn something completely new to me. I wanted to fast-track my
          graduation and find a job, so I was determined to finish the entire
          minor along with 2 specializations in only 2 semesters.Fast-forward to
          today -- I am graduating in a couple of weeks with my B.S. in
          Neuroscience and minor in Computer Programming, along with a couple of
          programming-related specializatios. I received a full-time software
          engineering offer at a wonderful company, so I'll be starting my new
          job in January 2023. I also really have been enjoying my classes, and
          want to further dive into computer science, so I will be pursuing an
          M.S. in Computer Science at Georgia Tech starting in January as well!
          With all going well, I happened to rescue a cat from my birthplace
          (Pasadena, CA). So, I now have an adorable kitten named Daisy!
        </p>

        <h2>My current favorite song:</h2>
        <iframe
          allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
          height="175"
          sandbox="allow-forms allow-same-origin allow-scripts allow-top-navigation-by-user-activation"
          src="https://embed.music.apple.com/in/album/pink-white/1146195596?i=1146195714"
        ></iframe>
      </div>
    </div>

    <div id="edu">
      <div className="main">
        <h1>Education and Work</h1>

        <div className="imagesforedu">
          <div>
            <img
              className="imgsedu"
              src={usc}
              alt="USC Logo"
            ></img>
          </div>
          <div>
            <img
              className="imgsedu"
              src={gtech}
              alt="Georgia Tech"
            ></img>
          </div>
          <div>
            <img
              className="imgsedu"
              src={slalom}
              alt="Slalom"
            ></img>
          </div>
        </div>

        <div className="imagesforedu">
          <Education></Education>
          <Work></Work>
          <PreWork></PreWork>
        </div>
      </div>
    </div>

    <div id="projects">
      <div className="main">
        <h1 className="projh1">Projects and Awards</h1>
        <div id="projsawardsandimgs">
          <div id="projawards">
            <Projects></Projects>
            <Awards></Awards>
          </div>

          <div id="projawardimgs">
            <div>
              <img
                id="imgsawrdawt"
                src={awt}
                alt="AWT"
              ></img>
            </div>
            <div>
              <img
                className="imgsawrd"
                src={qb}
                alt="Questbridge logo"
              ></img>
            </div>
            <div>
              <img
                className="imgsawrd"
                src={usclogo}
                alt="USC Logo"
              ></img>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="contact">
      <div className="main">
        <div className="hi"></div>
        <Form></Form>
      </div>
    </div>

    <div id="quotes">
      <div className="main">
        <div className="hi"></div>
        <h1 id="beforeugo">Before you go...</h1>
        <h2 id="beforeugo2">Enjoy some inspirational quotes!</h2>
        <Quotes></Quotes>
      </div>
    </div>
  </React.StrictMode>
);
